<template>
  <main class="comments" v-if="loaded">
    
    <div class="list-section">
        <CommentList />
        <Pagination v-if="(comments.length > $wpoptions.comments_per_page || totalPages.length > 1) || (currentPage > 1 && comments.length > 0) "/>
    </div>

    <div class="form-section">
        <h3>Post a comment</h3>
        <CommentForm :post="post" />
    </div>

  </main>
</template>

<script>
import CommentList from './CommentList.vue';
import CommentForm from './CommentForm.vue';

export default {

    data() {
        return {
            loaded: false,
            currentPage: 1
        }
    },
    components: {
        CommentList,
        CommentForm,
    },
    computed: {
        post() {
            return this.$store.state.post;
        },
        totalPages() {
            return this.$store.state.totalPages;
        },
        comments() {
            return this.$store.state.comments;
        },
        current() {
            return this.$store.state.current;
        }
    },
    methods: {
        getComments() {
            
            const comments_per_page = this.$wpoptions.comments_per_page;
            const comment_order = this.$wpoptions.comment_order;

            this.$store.dispatch('getComments', { post: this.post.id, parent: 0, per_page: comments_per_page, page: this.currentPage }).then(res => {   

                this.$store.state.totalPages = Array.from({length: res.headers['x-wp-totalpages']}, (value, key) => ++key); 
                
                this.$store.commit('setComments', res.data);
                this.loaded = true;
            })
        }

    },

    watch: {
        currentPage: function() {
            this.getComments();
        },
        post: function() {
            this.getComments();
        }
    },


}
</script>

<style lang="scss">
@import '../../scss/settings';

.comments {
    @include content-width;
    display: flex;
    margin: 0 auto;
    flex-direction: column;
    padding: rem-calc(32) 0 rem-calc(16) 0;

    > h2 {
        text-align: center;
    }
}


.list-section {
    flex: 4;

    .comment:nth-child(even) {
        background: rgba(0, 0, 0, .05);
    }
}

.form-section {
    flex: 2;

    > h3 {
        margin: 0;
    }
}

@include medium-up {
    .comments {
        flex-direction: row;
    }

    .form-section {
        min-width: rem-calc(320);
    }

    .list-section {
        padding-right: rem-calc(16);
    }


}


</style>